
const incomingMap: Record<string, string> = {
  "/documents/incoming:/documents/incoming::add": "add",
  "/documents/incoming:/documents/incoming::edit": "edit",
  "/documents/incoming::edit": "edit_additional",
  "/documents/incoming::remove": "del",
  "/documents/incoming:/documents/incoming::copy-to-tab": "copy_to_tab",
  "/documents/incoming:/documents/incoming::print": "print",
  "/documents/incoming:/documents/incoming::add-barcode": "add_barcode",
  "/documents/incoming::isModalOpen": "add_file",
  "/documents/incoming::isKepInternalModalOpen": "add_file",
  "/documents/incoming::isKepExternalModalOpen": "add_file",
  "/documents/incoming::isEditInfo": "edit_file_data",
  "/documents/incoming::isScan": "add_file",
  "/documents/incoming::sign-file": "sign_file",
  "/documents/incoming::save-files": "save_files",
  "/documents/incoming::delete-file": "del_file",
  "/documents/incoming::incoming-mail-download-files-from-mailbox": "load_file_mailbox",
  "/directories/passing:/documents/incoming::add-an-action-for-one-performer": "add_passing",
  "/directories/passing:/documents/incoming::add-an-action-from-a-template": "add_passing",
  "/directories/passing:/documents/incoming::edit": "edit_passing",
  "/directories/passing:/documents/incoming::delete": "del_passing",
  "/directories/related-documents:/documents/incoming::add": "add_related",
  "/directories/related-documents:/documents/incoming::edit": "edit_related",
  "/directories/related-documents:/documents/incoming::delete": "del_related",
  "/directories/discussion:/documents/incoming::add": "add_discussion",
  "/directories/discussion:/documents/incoming::edit": "edit_discussion",
  "/directories/discussion:/documents/incoming::delete": "del_discussion",
};

const outcomingMap: Record<string, string> = {
  "/documents/outcoming:/documents/outcoming::add": "add",
  "/documents/outcoming:/documents/outcoming::edit": "edit",
  "/documents/outcoming::edit": "edit_additional",
  "/documents/outcoming::remove": "del",
  "/documents/outcoming:/documents/outcoming::copy-to-tab": "copy_to_tab",
  "/documents/outcoming:/documents/outcoming::print": "print",
  "/documents/outcoming:/documents/outcoming::add-barcode": "add_barcode",
  "/documents/outcoming::isModalOpen": "add_file",
  "/documents/outcoming::isKepInternalModalOpen": "add_file",
  "/documents/outcoming::isKepExternalModalOpen": "add_file",
  "/documents/outcoming::isEditInfo": "edit_file_data",
  "/documents/outcoming::isScan": "add_file",
  "/documents/outcoming::sign-file": "sign_file",
  "/documents/outcoming::save-files": "save_files",
  "/documents/outcoming::delete-file": "del_file",
  "/documents/outcoming::create-letter": "create_letter",
  "/directories/passing:/documents/outcoming::add-an-action-for-one-performer": "add_passing",
  "/directories/passing:/documents/outcoming::add-an-action-from-a-template": "add_passing",
  "/directories/passing:/documents/outcoming::edit": "edit_passing",
  "/directories/passing:/documents/outcoming::delete": "del_passing",
  "/directories/related-documents:/documents/outcoming::add": "add_related",
  "/directories/related-documents:/documents/outcoming::edit": "edit_related",
  "/directories/related-documents:/documents/outcoming::delete": "del_related",
  "/directories/discussion:/documents/outcoming::add": "add_discussion",
  "/directories/discussion:/documents/outcoming::edit": "edit_discussion",
  "/directories/discussion:/documents/outcoming::delete": "del_discussion",
};

const internalMap: Record<string, string> = {
  "/documents/internal:/documents/internal::add": "add",
  "/documents/internal:/documents/internal::edit": "edit",
  "/documents/internal::edit": "edit_additional",
  "/documents/internal::remove": "del",
  "/documents/internal:/documents/internal::copy-to-tab": "copy_to_tab",
  "/documents/internal:/documents/internal::print": "print",
  "/documents/internal:/documents/internal::add-barcode": "add_barcode",
  "/documents/internal::isModalOpen": "add_file",
  "/documents/internal::isKepInternalModalOpen": "add_file",
  "/documents/internal::isKepExternalModalOpen": "add_file",
  "/documents/internal::isEditInfo": "edit_file_data",
  "/documents/internal::isScan": "add_file",
  "/documents/internal::sign-file": "sign_file",
  "/documents/internal::save-files": "save_files",
  "/documents/internal::delete-file": "del_file",
  "/documents/internal::create-letter": "create_letter",
  "/directories/passing:/documents/internal::add-an-action-for-one-performer": "add_passing",
  "/directories/passing:/documents/internal::add-an-action-from-a-template": "add_passing",
  "/directories/passing:/documents/internal::edit": "edit_passing",
  "/directories/passing:/documents/internal::delete": "del_passing",
  "/directories/related-documents:/documents/internal::add": "add_related",
  "/directories/related-documents:/documents/internal::edit": "edit_related",
  "/directories/related-documents:/documents/internal::delete": "del_related",
  "/directories/discussion:/documents/internal::add": "add_discussion",
  "/directories/discussion:/documents/internal::edit": "edit_discussion",
  "/directories/discussion:/documents/internal::delete": "del_discussion",
};

const resolutionsMap: Record<string, string> = {
  "/documents/resolutions:/documents/resolutions::edit": "edit",
  "/documents/resolutions::remove": "del",
  "/documents/resolutions:/documents/resolutions::print": "print",

  // =============================================================================================================
  // Треба ще додати наступні маршрути, після виправлення основної сторінки http://localhost:3000/documents/resolutions
  // add_performers
  // del_performers
};

const forSignatureMap: Record<string, string> = {
  "/documents/for-signature:/documents/for-signature::edit": "edit",
  "/documents/for-signature:/documents/for-signature::print": "print",
};

const electronicMailMap: Record<string, string> = {
  "/documents/electronic-mail::send-letter": "send_letter",
  "/documents/electronic-mail::remove": "del",
};

const typesOfDocumentsMap: Record<string, string> = {
  "/directories/types-of-documents:/directories/types-of-documents::add": "add",
  "/directories/types-of-documents:/directories/types-of-documents::edit": "edit",
  "/directories/types-of-documents::remove": "del",
};

const documentategoriesMap: Record<string, string> = {
  "/directories/document-categories:/directories/document-categories::add": "add",
  "/directories/document-categories:/directories/document-categories::edit": "edit",
  "/directories/document-categories::remove": "del",
};

const indexesofdocumentsMap: Record<string, string> = {
  "/directories/indexes-of-documents:/directories/indexes-of-documents::add": "add",
  "/directories/indexes-of-documents:/directories/indexes-of-documents::edit": "edit",
  "/directories/indexes-of-documents::remove": "del",
};

const actionswithdocumentsMap: Record<string, string> = {
  "/directories/actions-with-documents:/directories/actions-with-documents::add": "add",
  "/directories/actions-with-documents:/directories/actions-with-documents::edit": "edit",
  "/directories/actions-with-documents::remove": "del",
};

const resultsofactionsMap: Record<string, string> = {
  "/directories/results-of-actions:/directories/results-of-actions::add": "add",
  "/directories/results-of-actions:/directories/results-of-actions::edit": "edit",
  "/directories/results-of-actions::remove": "del",
};

const nomenclatureofcasescurrentMap: Record<string, string> = {
  "/directories/nomenclature-of-cases-current:/directories/nomenclature-of-cases-current::add": "add",
  "/directories/nomenclature-of-cases-current:/directories/nomenclature-of-cases-current::edit": "edit",
  "/directories/nomenclature-of-cases-current::remove": "del",
};

const nomenclatureofcasesMap: Record<string, string> = {
  "/directories/nomenclature-of-cases:/directories/nomenclature-of-cases::add": "add",
  "/directories/nomenclature-of-cases:/directories/nomenclature-of-cases::edit": "edit",
  "/directories/nomenclature-of-cases::remove": "del",
};

const typesofdeliveriesMap: Record<string, string> = {
  "/directories/types-of-deliveries:/directories/types-of-deliveries::add": "add",
  "/directories/types-of-deliveries:/directories/types-of-deliveries::edit": "edit",
  "/directories/types-of-deliveries::remove": "del",
};

const typesofcommunicationMap: Record<string, string> = {
  "/directories/types-of-communication:/directories/types-of-communication::add": "add",
  "/directories/types-of-communication:/directories/types-of-communication::edit": "edit",
  "/directories/types-of-communication::remove": "del",
};

const resolutiontemplatesMap: Record<string, string> = {
  "/directories/resolution-templates:/directories/resolution-templates::add": "add",
  "/directories/resolution-templates:/directories/resolution-templates::edit": "edit",
  "/directories/resolution-templates::remove": "del",
};

const typesofrelationshipsbetweendocumentsMap: Record<string, string> = {
  "/directories/types-of-relationships-between-documents:/directories/types-of-relationships-between-documents::add": "add",
  "/directories/types-of-relationships-between-documents:/directories/types-of-relationships-between-documents::edit": "edit",
  "/directories/types-of-relationships-between-documents::remove": "del",
};

const typesofreceiptsMap: Record<string, string> = {
  "/directories/types-of-receipts:/directories/types-of-receipts::add": "add",
  "/directories/types-of-receipts:/directories/types-of-receipts::edit": "edit",
  "/directories/types-of-receipts::remove": "del",
};

const structuralunitsMap: Record<string, string> = {
  "/directories/structural-units:/directories/structural-units::add": "add",
  "/directories/structural-units:/directories/structural-units::edit": "edit",
  "/directories/structural-units::remove": "del",
};

const typesofstructuralunitMap: Record<string, string> = {
  "/directories/types-of-structural-unit:/directories/types-of-structural-unit::add": "add",
  "/directories/types-of-structural-unit:/directories/types-of-structural-unit::edit": "edit",
  "/directories/types-of-structural-unit::remove": "del",
};

const positionsMap: Record<string, string> = {
  "/directories/positions:/directories/positions::add": "add",
  "/directories/positions:/directories/positions::edit": "edit",
  "/directories/positions::remove": "del",
};

const jobcategoriesMap: Record<string, string> = {
  "/directories/job-categories:/directories/job-categories::add": "add",
  "/directories/job-categories:/directories/job-categories::edit": "edit",
  "/directories/job-categories::remove": "del",
};

const professionclassifierMap: Record<string, string> = {
  "/directories/profession-classifier:/directories/profession-classifier::add": "add",
  "/directories/profession-classifier:/directories/profession-classifier::edit": "edit",
  "/directories/profession-classifier::remove": "del",
};

const employeesMap: Record<string, string> = {
  "/directories/employees:/directories/employees::add": "add",
  "/directories/employees:/directories/employees::edit": "edit",
  "/directories/employees::remove": "del",
};

const groupsofcorrespondentsMap: Record<string, string> = {
  "/directories/groups-of-correspondents:/directories/groups-of-correspondents::add": "add",
  "/directories/groups-of-correspondents:/directories/groups-of-correspondents::edit": "edit",
  "/directories/groups-of-correspondents::remove": "del",
};

const departmentaljournalsMap: Record<string, string> = {
  "/directories/departmental-journals:/directories/departmental-journals::add": "add",
  "/directories/departmental-journals:/directories/departmental-journals::edit": "edit",
  "/directories/departmental-journals::remove": "del",
};

const employeesandcontactpersonsMap: Record<string, string> = {
  "/directories/employees-and-contact-persons::contact-person": "add",
  "/directories/employees-and-contact-persons::employee": "add",
  "/directories/employees-and-contact-persons:/directories/employees-and-contact-persons::edit": "edit",
  "/directories/employees-and-contact-persons/contact-person:/directories/employees-and-contact-persons::remove": "del",
  "/directories/employees-and-contact-persons/employee:/directories/employees-and-contact-persons::remove": "del",
};

const correspondentsMap: Record<string, string> = {
  "/directories/correspondents:/directories/correspondents::add": "add",
  "/directories/correspondents:/directories/correspondents::edit": "edit",
  "/directories/correspondents::remove": "del",
};

const configuringpageaccessMap: Record<string, string> = {
  "/administration/configuring-page-access:/administration/configuring-page-access::add": "add",
  "/administration/configuring-page-access:/administration/configuring-page-access::edit": "edit",
  "/administration/configuring-page-access::remove": "del",
};

const buttonaccesssettingsMap: Record<string, string> = {
  "/administration/button-access-settings:/administration/button-access-settings::add": "add",
  "/administration/button-access-settings:/administration/button-access-settings::edit": "edit",
  "/administration/button-access-settings::remove": "del",
};

const serversettingsMap: Record<string, string> = {
  "/administration/server-settings:/administration/server-settings::add": "add",
  "/administration/server-settings:/administration/server-settings::edit": "edit",
  "/administration/server-settings::remove": "del",
};

const userssettingsMap: Record<string, string> = {
  "/administration/users:/administration/users::add": "add",
  "/administration/users:/administration/users::edit": "edit",
  "/administration/users::remove": "del",
};

const documentdisplayoptionsMap: Record<string, string> = {
  "/administration/document-display-options:/administration/document-display-options::add": "add",
  // "/administration/document-display-options:/administration/document-display-options::edit": "edit",
  "/administration/document-display-options::remove": "del",
};

const barcodeapplicationoptionsMap: Record<string, string> = {
  "/administration/barcode-application-options:/administration/barcode-application-options::add": "add",
  "/administration/barcode-application-options:/administration/barcode-application-options::edit": "edit",
  "/administration/barcode-application-options::remove": "del",
};

const mailboxesMap: Record<string, string> = {
  "/administration/mailboxes:/administration/mailboxes::add": "add",
  "/administration/mailboxes:/administration/mailboxes::edit": "edit",
  "/administration/mailboxes::remove": "del",
};

const mailboxesbyuserMap: Record<string, string> = {
  "/administration/mailboxes-by-user:/administration/mailboxes-by-user::add": "add",
  "/administration/mailboxes-by-user:/administration/mailboxes-by-user::edit": "edit",
  "/administration/mailboxes-by-user::remove": "del",
};

export const accessMaps: Record<string, Record<string, string>> = {
  incoming: incomingMap,
  outcoming: outcomingMap,
  internal: internalMap,
  resolutions: resolutionsMap,
  forsignature: forSignatureMap,
  electronicmail: electronicMailMap,
  typesofdocuments: typesOfDocumentsMap,
  documentategories: documentategoriesMap,
  indexesofdocuments: indexesofdocumentsMap,
  actionswithdocuments: actionswithdocumentsMap,
  resultsofactions: resultsofactionsMap,
  nomenclatureofcasescurrent: nomenclatureofcasescurrentMap,
  nomenclatureofcases: nomenclatureofcasesMap,
  typesofdeliveries: typesofdeliveriesMap,
  typesofcommunication: typesofcommunicationMap,
  resolutiontemplates: resolutiontemplatesMap,
  typesofrelationshipsbetweendocuments: typesofrelationshipsbetweendocumentsMap,
  typesofreceipts: typesofreceiptsMap,
  structuralunits: structuralunitsMap,
  typesofstructuralunit: typesofstructuralunitMap,
  positions: positionsMap,
  jobcategories: jobcategoriesMap,
  professionclassifier: professionclassifierMap,
  employees: employeesMap,
  groupsofcorrespondents: groupsofcorrespondentsMap,
  departmentaljournals: departmentaljournalsMap,
  employeesandcontactpersons: employeesandcontactpersonsMap,
  correspondents: correspondentsMap,
  configuringpageaccess: configuringpageaccessMap,
  buttonaccesssettings: buttonaccesssettingsMap,
  serversettings: serversettingsMap,
  userssettings: userssettingsMap,
  documentdisplayoptions: documentdisplayoptionsMap,
  barcodeapplicationoptions: barcodeapplicationoptionsMap,
  mailboxes: mailboxesMap,
  mailboxesbyuser: mailboxesbyuserMap,
};

export const pathRegexMap: [RegExp, keyof typeof accessMaps][] = [
  [/^\/documents\/incoming/, "incoming"],
  [/^\/documents\/outcoming/, "outcoming"],
  [/^\/documents\/internal/, "internal"],
  [/^\/documents\/resolutions/, "resolutions"],
  [/^\/documents\/for-signature/, "forsignature"],
  [/^\/documents\/electronic-mail/, "electronicmail"],
  [/^\/directories\/types-of-documents/, "typesofdocuments"],
  [/^\/directories\/document-categories/, "documentategories"],
  [/^\/directories\/indexes-of-documents/, "indexesofdocuments"],
  [/^\/directories\/actions-with-documents/, "actionswithdocuments"],
  [/^\/directories\/results-of-actions/, "resultsofactions"],
  [/^\/directories\/nomenclature-of-cases-current/, "nomenclatureofcasescurrent"],
  [/^\/directories\/nomenclature-of-cases/, "nomenclatureofcases"],
  [/^\/directories\/types-of-deliveries/, "typesofdeliveries"],
  [/^\/directories\/types-of-communication/, "typesofcommunication"],
  [/^\/directories\/resolution-templates/, "resolutiontemplates"],
  [/^\/directories\/types-of-relationships-between-documents/, "typesofrelationshipsbetweendocuments"],
  [/^\/directories\/types-of-receipts/, "typesofreceipts"],
  [/^\/directories\/structural-units/, "structuralunits"],
  [/^\/directories\/types-of-structural-unit/, "typesofstructuralunit"],
  [/^\/directories\/positions/, "positions"],
  [/^\/directories\/job-categories/, "jobcategories"],
  [/^\/directories\/profession-classifier/, "professionclassifier"],
  [/^\/directories\/employees-and-contact-persons/, "employeesandcontactpersons"],
  [/^\/directories\/employees/, "employees"],
  [/^\/directories\/groups-of-correspondents/, "groupsofcorrespondents"],
  [/^\/directories\/departmental-journals/, "departmentaljournals"],
  [/^\/directories\/correspondents/, "correspondents"],
  [/^\/administration\/configuring-page-access/, "configuringpageaccess"],
  [/^\/administration\/button-access-settings/, "buttonaccesssettings"],
  [/^\/administration\/server-settings/, "serversettings"],
  [/^\/administration\/users/, "userssettings"],
  [/^\/administration\/document-display-options/, "documentdisplayoptions"],
  [/^\/administration\/barcode-application-options/, "barcodeapplicationoptions"],
  [/^\/administration\/mailboxes-by-user/, "mailboxesbyuser"],
  [/^\/administration\/mailboxes/, "mailboxes"],
]